import React, { useState } from "react";
import { Filter, X } from "lucide-react";

/**
 * Mobile-responsive layout with collapsible filter sidebar.
 * On desktop: side-by-side (sidebar + main).
 * On mobile: sidebar hidden by default, toggled via floating button.
 */
export function MobileFilterToggle({ showFilter, setShowFilter }) {
  return (
    <>
      {/* Mobile overlay */}
      {showFilter && (
        <div className="fixed inset-0 bg-black/40 z-30 lg:hidden" onClick={() => setShowFilter(false)} />
      )}
      {/* Mobile filter toggle button */}
      <button
        onClick={() => setShowFilter(true)}
        className="fixed bottom-20 left-4 z-20 lg:hidden bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700"
        data-testid="mobile-filter-toggle"
      >
        <Filter className="w-5 h-5" />
      </button>
    </>
  );
}

export function MobileFilterClose({ setShowFilter }) {
  return (
    <div className="flex justify-between items-center lg:hidden mb-2">
      <span className="text-sm font-bold text-gray-700 dark:text-slate-200">Bộ lọc</span>
      <button onClick={() => setShowFilter(false)} className="p-1 rounded hover:bg-gray-200 dark:hover:bg-slate-600">
        <X className="w-5 h-5" />
      </button>
    </div>
  );
}

/** CSS classes for responsive sidebar */
export const sidebarClasses = (showFilter) => `
  w-[280px] min-w-[280px] border-r border-gray-200 dark:border-slate-700 overflow-y-auto p-4 space-y-5 bg-gray-50 dark:bg-slate-800/50
  fixed lg:static inset-y-0 left-0 z-40 transition-transform duration-200 pt-16 lg:pt-4
  ${showFilter ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}
`;
